import { NavigateFunction } from 'react-router-dom';

export const handleVideoClick = async (resourceId: string, navigate: NavigateFunction, backEnabled: boolean = false) => {
  const queryParams = backEnabled ? '?back_enabled=true' : '';
  navigate(`/summary/${resourceId}${queryParams}`);
};
